<nz-page-header nzTitle="Approval Settings"></nz-page-header>

<nz-row [nzGutter]="16" *ngIf="form">

	<!-- MAIN -->
	<nz-col nzSpan="16">

		<nz-card nzTitle="Approval Levels" [nzExtra]="addBtn">

			<form [formGroup]="form">

				<nz-table nzBordered nzSize="small" [nzData]="levels.controls" [nzShowPagination]="false">
					<thead>
						<tr>
							<th nzWidth="80px">Level</th>
							<th nzWidth="200px">Minimum Amount</th>
							<th>Agents</th>
							<th nzWidth="60px"></th>
						</tr>
					</thead>

					<tbody formArrayName="levels">
						<tr *ngFor="let level of levels.controls; let i = index" [formGroupName]="i">

							<td><strong>{{ i + 1 }}</strong></td>

							<td>
								<nz-input-number formControlName="paymentThreshold" [nzMin]="0" [nzStep]="1000"
									nzPlaceHolder="Min amount">
								</nz-input-number>
							</td>

							<td>
								<nz-select formControlName="allowedAgentIds" nzMode="multiple" nzPlaceHolder="Select agents" nzAllowClear style="width: 100%;">
									<nz-option *ngFor="let a of agents" [nzValue]="a.id" [nzLabel]="a.username!">
									</nz-option>
								</nz-select>
							</td>

							<td class="text-center">
								<button nz-button nzType="text" nzDanger (click)="removeLevel(i)">
									<span nz-icon nzType="delete"></span>
								</button>
							</td>

						</tr>
					</tbody>
				</nz-table>

				<!-- Validation -->
				<div *ngIf="hasDuplicateThresholds()" class="mt-2">
					<nz-alert nzType="error" nzMessage="Duplicate minimum amounts are not allowed" nzShowIcon>
					</nz-alert>
				</div>

				<!-- Save -->
				<div style="text-align:right; margin-top:16px;">
					<button nz-button nzType="primary" (click)="save()">
						Save Settings
					</button>
				</div>

			</form>

		</nz-card>

		<ng-template #addBtn>
			<button nz-button nzType="dashed" (click)="addLevel()">
				<span nz-icon nzType="plus"></span>
				Add Level
			</button>
		</ng-template>

	</nz-col>

	<!-- SIDE INFO -->
	<nz-col nzSpan="8">
		<nz-card nzTitle="Approval Logic">
			<p class="text-muted">
				Tiered approval levels.
			</p>

			<pre>Invoice amount ≥ level threshold.</pre>

			<ul>
				<li>A invoice will be queued for approval at each level where the invoice amount is greater or equal to the threshold</li>
				<li>Threshold order does not matter, levels will be adjusted accordingly</li>
			</ul>
		</nz-card>
	</nz-col>

</nz-row>
